import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpModule, XHRBackend, ConnectionBackend, RequestOptions } from '@angular/http';
import { TranslateModule } from '@ngx-translate/core';

import { AuthenticationService } from 'app/core/authentication/authentication.service';
import { AuthenticationGuard } from 'app/core/authentication/authentication.guard';
import { I18nService } from 'app/core/i18n.service';
import { HttpService } from 'app/core/http/http.service';
import { HttpCacheService } from 'app/core/http/http-cache.service';
import { UserService } from 'app/core/user/user.service';
import { LookupService } from 'app/core/lookup/lookup.service';

export function createHttpService(backend: ConnectionBackend,
  defaultOptions: RequestOptions,
  httpCacheService: HttpCacheService) {
  return new HttpService(backend, defaultOptions, httpCacheService);
}

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    TranslateModule,
    RouterModule,
  ],
  declarations: [],
  providers: [
    AuthenticationService,
    AuthenticationGuard,
    I18nService,
    HttpService,
    HttpCacheService,
    UserService,
    {
      provide: HttpService,
      deps: [XHRBackend, RequestOptions, HttpCacheService],
      useFactory: createHttpService
    },
    LookupService
  ]
})
export class CoreModule {

  constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
    // Import guard
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
    }
  }

}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/core/core.module.ts